module.exports = __webpack_public_path__ + "static/media/tournaments-history-active-menu-icon.17debaf4.svg";